/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import New from './New/index'
import No from './No/index'
import Old from './Old/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let globalFeatureFlagsIsNewAppointmentOverlayEnabledValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'feature_flags.is_new_appointment_overlay_enabled',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: globalFeatureFlagsIsNewAppointmentOverlayEnabledValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Old'}>
<Old
  viewPath={`${viewPath}/Old`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'New'}>
<New
  viewPath={`${viewPath}/New`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}